<template>
  <div class="activePickupBox" v-if="activePickupBox">
    <div class="activePickupBox__header">
      <p>{{ $t('boxInfo') }}</p>
      <div class="activePickupBox__header-actions">
        <img
          src="@/assets/icons/Capacity.svg"
          alt=""
          @click="capacityPickupBox"
          data-testid="activePickupBoxCapacity"
        />
        <img
          class="activePickupBox__header-actions-img"
          src="@/assets/icons/Edit.svg"
          alt=""
          @click="editPickupBox()"
          data-testid="activePickupBoxEdit"
        />
      </div>
    </div>
    <div class="activePickupBox__main">
      <InfoActiveBox :activePickupBox="activePickupBox" />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import InfoActiveBox from './InfoActiveBox/InfoActiveBox.vue';

import router from '@/router';

@Options({
  name: 'ActiveBox',
  props: ['activePickupBox'],
  components: {
    InfoActiveBox
  },
  methods: {
    capacityPickupBox() {
      router.push({
        name: 'CapacityPickupBox',
        params: { boxId: this.activePickupBox.info.id }
      });
    },
    editPickupBox() {
      const { id } = this.$route.params;

      router.push({
        name: 'EditPickupBox',
        params: { pharmacyId: id, boxId: this.activePickupBox.info.id }
      });
    }
  }
})
export default class ActiveBoxComponent extends Vue {}
</script>

<style lang="scss" scoped>
.activePickupBox {
  height: 100%;
  width: 100%;
  margin-top: 22px;
  background-color: $light-grey;
  border: 1px solid $border;
  border-radius: 8px;
  padding-bottom: 32px;
  overflow-y: scroll;
  .activePickupBox__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0 13px 24px;
    border-bottom: 1px solid $border;
    background-color: $light-grey;
    p {
      font-family: 'Ubuntu-Medium';
      font-size: $fourteenSize;
      background-color: $light-grey;
    }
    .activePickupBox__header-actions {
      background-color: $light-grey;
      img {
        margin-right: 22px;
        cursor: pointer;
        background-color: $light-grey;
      }
      .container {
        display: inline-block;
        background-color: $light-grey;
        .activePickupBox__header-actions-img {
          margin-right: 18px;
          cursor: pointer;
          background-color: $light-grey;
        }
      }
    }
  }
  .activePickupBox__main {
    margin-left: 25px;
    background-color: $light-grey;
  }
}
</style>
